/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React from 'react'
import {
  StyledContainer,
  PostContainer,
  MediaSection,
  PlayButton,
  ContentSection,
  CategoryTags,
  CategoryTag,
  HashtagText,
  PostText,
  CommentSection,
  CommentInput,
  ReplyButton,
  StatValue,
  StatLabel,
  StatsPostContainer,
  ProfileSection,
  ProfileImage,
  ProfileInfo,
  ProfileHandle,
  ProfilePlatform,
  StatsSection,
  StatColumn,
  OtherPostsTitle,
  PostsGrid,
  PostCard,
  PostCardHeader,
  CategoryWrapper,
  PostCategory,
  PlatformIcon,
  PostImage,
  PostContent,
  HashTag,
  PostDescription,
  ReplyButtonWrapper,
  CardWrapper,
} from './Style'
import ErrorIcon from '@mui/icons-material/Error'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import { Icons } from 'constants/icon'
import {
  Box,
  Typography,
  Alert,
  Button,
  CircularProgress,
  Divider,
  List,
  ListItem,
  ListItemText,
} from '@mui/material'
import ButtonPrimary from 'components/ButtonPrimary/ButtonPrimary'
import { useLocation, useNavigate } from 'react-router-dom'
import { DEFAULT_AVATAR_URL, DEFAULT_URL_LINK } from 'components/HitCard/Utils'
import {
  ReplyIcon,
  VideoContainer,
  ReplyButton as HitCardReplyButton,
} from 'components/HitCard/StyleHit'
import SocialMediaIcon from 'components/SocialMediaIcon/SocialMediaIcon'
import { useInteractedWithHitMutation } from '../../graphql/generated/graphql'
import axios from 'axios'
import { Colors } from 'constants/colors'
import { shortenString } from 'utils/shortenString'
import HitModalStyle from 'components/HitDetailsModal/Style'
import { Platform, useGetResponseLazyQuery } from 'graphql/generated/graphql'

interface ResponseType {
  comment1: string
  comment2: string
  comment3: string
}

export default function PostDetails(): JSX.Element {
  const navigate = useNavigate()
  const location = useLocation()
  const { state } = location || {}
  const { body, headerProps, youtubeHits, redditHits } = state || {}
  // console.log('');
  const [value, setValue] = React.useState('')
  const [loading, setIsLoading] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState<null | string>(null)
  const [isVideo, setIsVideo] = React.useState<boolean>(false)
  const [redditHtml, setRedditHtml] = React.useState('')
  const hashtags = body?.match(/#\w+/g) ?? []
  const bodyWithoutHashtags = body.replace(/#\w+/g, '').trim()
  const [addInteraction] = useInteractedWithHitMutation()
  const [getResponse, { loading: responseLoading, error, data }] =
    useGetResponseLazyQuery()
  const [responses, setResponses] = React.useState<ResponseType | undefined>()

  const filterYoutubeList = youtubeHits
    ?.filter((item: { name: any }) => {
      return item.name === headerProps.creator.name
    })
    .filter((item: { content: any }) => item.content !== headerProps.content)

  const filterRedditList = redditHits
    ?.filter((item: { name: any }) => {
      return item.name === headerProps.creator.name
    })
    .filter((item: { content: any }) => item.content !== headerProps.content)

  const getRedditEmbed = React.useCallback(async () => {
    if (headerProps.platform === 'Reddit') {
      const redditUrl = `https://www.reddit.com/oembed?url=https://reddit.com${headerProps.postURL}/`
      const result = await axios.get(`/reddit-proxy?url=${redditUrl}`)
      setRedditHtml(result.data?.html)
    }
  }, [])

  const handleRespond = (): void => {
    if (headerProps.platform === 'Youtube') {
      return respondYoutube()
    } else if (headerProps.platform === 'Reddit') {
      return respondReddit()
    } else {
      console.log(headerProps.platform)
    }
  }

  // const returnEmbed = (): JSX.Element => {
  //   if (headerProps.platform === 'Youtube') {
  //     return (
  //       <div
  //         style={{
  //           display: 'flex',
  //           justifyContent: 'center',
  //         }}
  //       >
  //         <iframe
  //           width={600}
  //           height={400}
  //           style={{ border: 'none' }}
  //           src={`https://www.youtube.com/embed/${headerProps.hitItemId}`}
  //         ></iframe>
  //       </div>
  //     )
  //   } else if (headerProps.platform === 'Reddit') {
  //     return <div dangerouslySetInnerHTML={{ __html: redditHtml }} />
  //   }
  // }

  const respondReddit = (): void => {
    setIsLoading(true)
    const accessToken = localStorage.getItem('redditToken')
    const url = 'https://oauth.reddit.com/api/comment'
    const data = {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      thing_id: `t3_${headerProps.hitItemId}`,
      text: value,
      api_type: 'json',
    }
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `bearer ${accessToken ?? ''}`,
      // 'User-Agent': 'Nalopod v1 (by u/Dazzling_Price_5207)',
    }
    axios
      .post(url, data, {
        headers,
      })
      .then(async (res) => {
        if (!headerProps.interactedWith) {
          await addInteraction({
            variables: {
              campaignId: headerProps.campaignId ?? '',
              hitId: headerProps.hitItemId,
            },
          })
        }
        setIsLoading(false)
        setValue('')
        setErrorMessage(null)
      })
      .catch((e) => {
        if (e.response) {
          if (e.response.status === 401) {
            setErrorMessage(
              'Please connect your socials before replying to this hit. To connect your socials, go to "Connect Social" section in our app.'
            )
          } else {
            setErrorMessage(
              e.response.data.message ??
                'Something went wrong please try again later.'
            )
          }
        } else {
          setErrorMessage(
            'An unexpected error occurred. Please try again later.'
          )
        }
        setIsLoading(false)
        console.error(e)
      })
  }

  const respondYoutube = (): void => {
    setIsLoading(true)
    const accessToken = localStorage.getItem('google_access_token')
    const url =
      'https://www.googleapis.com/youtube/v3/commentThreads?part=id,snippet'
    const data = {
      snippet: {
        videoId: headerProps.hitItemId,
        topLevelComment: {
          snippet: {
            textOriginal: value,
          },
        },
      },
    }
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken ?? ''}`,
    }
    axios
      .post(url, JSON.stringify(data), {
        headers,
      })
      .then(async (res) => {
        if (!headerProps.interactedWith) {
          await addInteraction({
            variables: {
              campaignId: headerProps.campaignId ?? '',
              hitId: headerProps.hitItemId,
            },
          })
        }
        setIsLoading(false)
        setValue('')
        setErrorMessage(null)
      })
      .catch((e) => {
        if (e.response) {
          if (e?.response?.status === 401) {
            setErrorMessage(
              'Please connect your socials before replying to this hit. To connect your socials, go to "Connect Social" section in our app.'
            )
          } else {
            setErrorMessage(
              e.response.data.message ??
                'Something went wrong please try again later.'
            )
          }
        } else {
          setErrorMessage(
            'An unexpected error occurred. Please try again later.'
          )
        }
        setIsLoading(false)
        console.error(e)
      })
  }

  React.useEffect(() => {
    void getRedditEmbed()
  }, [])

  React.useEffect(() => {
    const { postURL } = headerProps ?? {}
    if (postURL) {
      const isReel = postURL.includes('/reel/')
      const isVideo = postURL.includes('/video/') || isReel
      setIsVideo(isVideo)
    } else {
      setIsVideo(false)
    }
  }, [headerProps])

  React.useEffect(() => {
    if (data?.respond !== '{}' && data) {
      const parsed = JSON.parse(data.respond)
      setResponses(parsed)
    }
  }, [data])

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const formatFollowersCount = (count: number) => {
    if (count < 1000) {
      return count.toString()
    } else if (count < 1000000) {
      return (count / 1000).toFixed(0) + 'k'
    } else {
      return (count / 1000000).toFixed(1) + 'M'
    }
  }

  return (
    <StyledContainer>
      <ButtonPrimary
        variant="outlined"
        buttonTitle="Go back"
        onClick={() => navigate(-1)}
      ></ButtonPrimary>
      <PostContainer
        sx={{
          marginTop: '20px',
          marginBottom: '40px',
        }}
      >
        <MediaSection>
          {/* {returnEmbed()} */}
          {isVideo ? (
            <>
              <VideoContainer
                sx={{
                  cursor: 'pointer',
                }}
              >
                <video
                  src={
                    headerProps.platform === 'Youtube'
                      ? `https://www.youtube.com/embed/${headerProps.hitItemId}`
                      : headerProps?.imageSource || DEFAULT_URL_LINK
                  }
                  poster={
                    headerProps?.thumbnail ||
                    headerProps?.imageSource ||
                    DEFAULT_URL_LINK
                  }
                  controls={false}
                  autoPlay={false}
                  muted
                  loop
                  playsInline
                />
                <PlayButton>
                  <PlayArrowIcon />
                </PlayButton>
              </VideoContainer>
            </>
          ) : (
            <>
              <img
                src={headerProps?.imageSource || DEFAULT_URL_LINK}
                alt=""
                loading="lazy"
              />
            </>
          )}
        </MediaSection>
        <ContentSection>
          <CategoryTags>
            <Box
              sx={{
                display: 'flex',
                gap: '10px',
                flexWrap: 'wrap',
                marginBottom: '12px',
              }}
            >
              {hashtags
                .slice(0, 2)
                .map(
                  (hash: string | null | undefined) =>
                    hash && (
                      <CategoryTag key={hash}>
                        {hash.replace('#', '')}
                      </CategoryTag>
                    )
                )}
            </Box>
            <Box
              sx={{
                marginLeft: 'auto',
              }}
            >
              <SocialMediaIcon
                platformName={headerProps?.platform}
                width={37}
              />
            </Box>
          </CategoryTags>
          <Box
            sx={{
              display: 'flex',
              gap: '10px',
              flexWrap: 'wrap',
              marginBottom: '12px',
            }}
          >
            {hashtags
              .slice(0, 3)
              .map(
                (
                  hash:
                    | boolean
                    | React.Key
                    | React.ReactElement<
                        any,
                        string | React.JSXElementConstructor<any>
                      >
                    | React.ReactFragment
                    | null
                    | undefined,
                  index: number
                ) =>
                  hash && (
                    <HashtagText key={`hashtag-${index}`}>
                      {String(hash)}
                    </HashtagText>
                  )
              )}
            {hashtags.length > 3 && (
              <HashtagText>+{hashtags.length - 3}</HashtagText>
            )}
          </Box>
          <PostText>{bodyWithoutHashtags}</PostText>
          <HitModalStyle.TitleWrapper>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <HitModalStyle.ChatIconStyle />
              <HitModalStyle.SectionTitle>Respond</HitModalStyle.SectionTitle>
            </div>
            <Button
              variant="outlined"
              color="success"
              disabled={responseLoading || Boolean(data)}
              onClick={() => {
                getResponse({
                  variables: {
                    platform: headerProps.platform as Platform,
                    videoId: headerProps.hitItemId,
                    content: body,
                  },
                }).catch((e) => console.log(e))
              }}
            >
              Recommend response
            </Button>
          </HitModalStyle.TitleWrapper>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
              paddingBottom: '10px',
            }}
          >
            {responseLoading && <CircularProgress />}
            {responses && !responseLoading && (
              <div
                style={{
                  width: '100%',
                }}
              >
                <List
                  component="nav"
                  sx={{
                    bgcolor: 'grey.900',
                    borderRadius: '4px',
                    boxShadow: '0px 2px 4px rgba(255, 255, 255, 0.1)',
                    color: 'grey.300',
                  }}
                >
                  <ListItem
                    button
                    onClick={() => setValue(responses?.comment1 ?? value)}
                    sx={{
                      '&:hover': {
                        bgcolor: 'grey.800',
                      },
                    }}
                  >
                    <ListItemText
                      primary={responses?.comment1}
                      primaryTypographyProps={{ color: 'inherit' }}
                    />
                  </ListItem>
                  <Divider sx={{ bgcolor: 'grey.700' }} />
                  <ListItem
                    button
                    divider
                    onClick={() => {
                      setValue(responses?.comment2 ?? value)
                    }}
                    sx={{
                      '&:hover': {
                        bgcolor: 'grey.800',
                      },
                    }}
                  >
                    <ListItemText
                      primary={responses?.comment2}
                      primaryTypographyProps={{ color: 'inherit' }}
                    />
                  </ListItem>
                  <ListItem
                    button
                    onClick={() => setValue(responses?.comment3 ?? value)}
                    sx={{
                      '&:hover': {
                        bgcolor: 'grey.800',
                      },
                    }}
                  >
                    <ListItemText
                      primary={responses?.comment3}
                      primaryTypographyProps={{ color: 'inherit' }}
                    />
                  </ListItem>
                </List>
              </div>
            )}
            {!responses && data && (
              <Alert severity="info">
                We couldn&apos;t recommend any responses
              </Alert>
            )}
            {error && (
              <Alert severity="error">
                Something went wrong, please try again!
              </Alert>
            )}
          </div>
          <CommentSection>
            <CommentInput
              placeholder="Write your response here..."
              multiline
              rows={4}
              disabled={loading}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              sx={errorMessage ? { borderColor: Colors.error } : {}}
              inputProps={{ maxLength: 10000 }}
            />
            {errorMessage && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <ErrorIcon sx={{ color: Colors.error }} />
                <Typography sx={{ color: Colors.error }}>
                  {errorMessage}
                </Typography>
              </div>
            )}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'end',
              }}
            >
              <ReplyButton
                onClick={() => handleRespond()}
                disabled={loading || value.trim().length === 0}
              >
                REPLY
                <span className="arrow">→</span>
              </ReplyButton>
            </Box>
          </CommentSection>
        </ContentSection>
      </PostContainer>
      <StatsPostContainer
        sx={{
          marginBottom: '40px',
        }}
      >
        <ProfileSection>
          <ProfileImage
            src={headerProps?.avatar ?? DEFAULT_AVATAR_URL}
            alt=""
            loading="lazy"
          />
          <ProfileInfo>
            <ProfileHandle>{headerProps.creator.name}</ProfileHandle>
            <ProfilePlatform>{headerProps?.platform}</ProfilePlatform>
            {/* <ProfileBio>Bio Here</ProfileBio> */}
          </ProfileInfo>
        </ProfileSection>

        <StatsSection>
          <StatColumn>
            <StatLabel>FOLLOWERS</StatLabel>
            <StatValue>
              {formatFollowersCount(headerProps.followersCount)}
            </StatValue>
          </StatColumn>
          <StatColumn>
            <StatLabel>POSTS</StatLabel>
            <StatValue>
              {headerProps?.platform === 'Youtube'
                ? (filterYoutubeList?.length ?? 0) + 1
                : headerProps?.platform === 'Reddit'
                ? (filterRedditList?.length ?? 0) + 1
                : 0}
            </StatValue>
          </StatColumn>
          {/* <StatColumn>
            <StatLabel>FOLLOWING</StatLabel>
            <StatValue>1.3k</StatValue>
          </StatColumn> */}
        </StatsSection>
      </StatsPostContainer>
      <>
        {(
          headerProps?.platform === 'Youtube'
            ? filterYoutubeList?.length > 0
            : filterRedditList?.length > 0
        ) ? (
          <OtherPostsTitle>Other Pulled Posts From Creator</OtherPostsTitle>
        ) : null}
        <PostsGrid>
          {(headerProps?.platform === 'Youtube'
            ? filterYoutubeList
            : filterRedditList
          )
            ?.slice(0, 3)
            ?.map(
              (
                post: {
                  content: {
                    match: (arg0: RegExp) => never[]
                    replace: (arg0: RegExp, arg1: string) => string
                  }
                  id: React.Key | null | undefined
                  interaction: {
                    tag:
                      | string
                      | number
                      | boolean
                      | React.ReactElement<
                          any,
                          string | React.JSXElementConstructor<any>
                        >
                      | React.ReactFragment
                      | React.ReactPortal
                      | null
                      | undefined
                    positive: any
                    shared: any
                    followers: any
                  }
                  platforms: string[]
                  platform: string | undefined
                  thumbnail: any
                  interactedWith: any
                  name: any
                  date: any
                  creator: { avatarUrl: any }
                  keywords: any
                  campaignName: any
                  postURL: any
                },
                index: React.Key | null | undefined
              ) => {
                const hashtagsList = post?.content?.match(/#\w+/g) ?? []
                const bodyWithoutHashtag = post.content
                  .replace(/#\w+/g, '')
                  .trim()
                return (
                  <CardWrapper key={post.id}>
                    <PostCard key={post.id}>
                      <PostCardHeader>
                        <CategoryWrapper>
                          <PostCategory key={index}>
                            {post?.interaction?.tag}
                          </PostCategory>
                        </CategoryWrapper>
                        <PlatformIcon
                          src={
                            post.platforms[0] === 'Youtube'
                              ? Icons.bYoutube
                              : Icons.bReddit
                          }
                          alt={post.platform}
                        />
                      </PostCardHeader>
                      <PostImage>
                        <img
                          src={post.thumbnail || DEFAULT_URL_LINK}
                          alt={''}
                          loading="lazy"
                        />
                      </PostImage>
                      <PostContent>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: '10px',
                            flexWrap: 'wrap',
                            marginBottom: '10px',
                          }}
                        >
                          {hashtagsList?.slice(0, 1)?.map((hash: string) => (
                            <HashTag key={hash}>
                              {hash.replace('#', '')}
                            </HashTag>
                          ))}
                          {hashtagsList.length > 1 && (
                            <HashTag>+{hashtagsList.length - 1}</HashTag>
                          )}
                        </Box>
                        <PostDescription>
                          {shortenString(bodyWithoutHashtag, 100)}
                        </PostDescription>
                        <ReplyButtonWrapper>
                          <HitCardReplyButton
                            className={
                              post.interactedWith ? 'replied' : 'no-reply'
                            }
                            onClick={() => {
                              if (post.interactedWith) return
                              navigate('/postdetails', {
                                state: {
                                  body: post.content || '',
                                  headerProps: {
                                    ...post,
                                    hitItemId: post.id,
                                    authorName: post.name,
                                    date: Number(post.date),
                                    imageSource:
                                      post.thumbnail ??
                                      'https://media.istockphoto.com/id/1147544806/vector/no-thumbnail-image-vector-graphic.jpg?s=170667a&w=0&k=20&c=-r15fTq303g-Do1h-F1jLdxddwkg4ZTtkdQK1XP2sFk=',
                                    reactionCount: post.interaction.positive,
                                    shareCount: post.interaction.shared ?? 0,
                                    followersCount: post.interaction.followers,
                                    platform: post.platforms[0],
                                    avatar: post.creator.avatarUrl ?? undefined,
                                    keyword: post?.keywords,
                                    campaignName:
                                      post?.campaignName ?? undefined,
                                    postURL: post.postURL,
                                    interactedWith: post.interactedWith,
                                    tag: post.interaction.tag,
                                  },
                                  youtubeHits:
                                    post.platforms[0] === 'Youtube'
                                      ? youtubeHits
                                      : [],
                                  redditHits:
                                    post.platforms[0] === 'Reddit'
                                      ? redditHits
                                      : [],
                                },
                              })
                            }}
                          >
                            {post.interactedWith ? (
                              <>
                                <ReplyIcon src={Icons.gCheck} alt="Replied" />
                                REPLIED
                              </>
                            ) : (
                              <>
                                REPLY
                                <ReplyIcon
                                  src={Icons.wRightArrow}
                                  alt="Reply"
                                />
                              </>
                            )}
                          </HitCardReplyButton>
                        </ReplyButtonWrapper>
                      </PostContent>
                    </PostCard>
                  </CardWrapper>
                )
              }
            )}
        </PostsGrid>
      </>
    </StyledContainer>
  )
}
